<script setup lang="ts">
import organizationApi from '@/services/organization.service'
import store from '@/store'
import { EAlertActions } from '@/store/alertStore/AlertStoreTypes'
import { EStoreModules } from '@/store/storeType'
import moment from 'moment'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import type { RentalDateModel } from '../../../types/models/RentalModel'
import DeviceRentalActions from './DeviceRentalActions.vue'

type Props = {
    rentalId: number
    data: RentalDateModel
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const { t } = useI18n()

const organizationId = computed(() => store.state.authentication.me.organization_id)
const loading = ref(false)
const open = ref(false)
const date = ref({
    ...props.data
})
watch(
    () => props.data,
    newDates => (date.value = { ...newDates })
)

const confirmUpdate = () => {
    if (!organizationId.value) return
    loading.value = true
    organizationApi
        .updateRental(props.rentalId, organizationId.value, date.value)
        .then(() => {
            open.value = false
            date.value = {
                start_at: new Date(),
                end_at: new Date()
            }
            store.dispatch(`${EStoreModules.ALERT}/${EAlertActions.QUEUE_ITEM}`, {
                action: EAlertActions.SUCCESS,
                message: t('device.rental.updateRentalApiSuccess')
            })
        })
        .finally(() =>
            setTimeout(() => {
                emit('refresh')
                loading.value = false
            }, 5000)
        )
}
</script>

<template>
    <DeviceRentalActions
        :loading="loading"
        :open="open"
        :valueDate="date"
        :title="$t('device.rental.updateCurrentRentalTitle')"
        :label="$t('device.rental.updateCurrentRentalAction')"
        :startDateProps="{
            minDatetime: moment().toDate()
        }"
        @change="date = { ...date, ...$event }"
        @confirm="confirmUpdate"
        @open="open = $event" />
</template>
